import React, { useEffect } from 'react';
import { useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/vote/vote.css";
import searchIcon from "../../images/chats/search_icon.png";

const VoteScreen = () => {
    const [getSearch, setSearch] = useState("");
    
    const [getOriginalList] = useState([
        "Action", "Thriller", "Mystery", "Comedy", 
        "Horror", "Family", "Animation", "Adventure", 
        "Drama", "Romance", "Science Fiction", "News", 
        "Kids", "Reality", "Soap", "Talk", "War",
        "Western", "History", "Documentary", "Fantasy",
        "Crime", "Music"
    ]);
    const [getMajorList, setMajorList] = useState([]);

    const onChangeSearch = (search) => {
        setSearch(search.target.value);
    };

    useEffect(() => {
        const filteredList = getOriginalList.filter((item) => {
            return item && item.toLowerCase().includes(getSearch.toLowerCase());
        });

        setMajorList(filteredList);
    }, [getSearch, getOriginalList]);
    
    return(
        <div className="vote_screen">
            <p className="view_collections_header">Monthly Vote</p>
            <div className="vote_screen_divider"></div>
            <div className="vote_screen_search_input_container_i">
                    <div className="vote_screen_search_input_container">
                        <img alt='search' src={searchIcon} className="vote_screen_search_input_icon"/>
                        <input className="vote_screen_search_input_field" id="item_section_search" placeholder={`Search for any category`} type="text" value={getSearch} onChange={onChangeSearch} />
                    </div>
                </div>
            <div className="vote_screen_content">
                {
                    getMajorList.length > 0
                    ? getMajorList.map((card, index) => (
                        <div key={index} className="vote_screen_rows">
                            <Link to={`/main_back/vote/${card.toLowerCase() === "science fiction" ? "science-fiction" : card.toLowerCase()}/movies`} className="vote_screen_link"><div className="vote_screen_card">
                                <p className="vote_screen_card_head">{card}</p>
                                <p className="vote_screen_card_sub">Movies</p>
                            </div></Link>
                            <Link to={`/main_back/vote/${card.toLowerCase() === "science fiction" ? "science-fiction" : card.toLowerCase()}/series`} className="vote_screen_link"><div className="vote_screen_card">
                                <p className="vote_screen_card_head">{card}</p>
                                <p className="vote_screen_card_sub">Tv Series</p>
                            </div></Link>
                        </div>
                    ))
                    : <p style={{alignSelf: 'center', color: 'aliceblue', fontSize: '18px', textAlign: 'center'}}>There are no categories based on your search "{getSearch}"</p>
                }
            </div>
        </div>
    );
};

export default VoteScreen;